import React, { useMemo } from "react";

import Autocomplete from "@material-ui/lab/Autocomplete";

import { TextField } from "@material-ui/core";

import useFetchCatalogedTrackers from "../queries/useFetchCatalogedTrackers";
import { NamedTrackerInfo } from "../types";

export type CatalogedTrackerDropdownProps = {
  autoFocus?: boolean;
  disabled: boolean;
  error?: boolean;
  onChange: (value?: NamedTrackerInfo) => void;
  value?: NamedTrackerInfo;
};

function CatalogedTrackerAutocomplete({
  autoFocus,
  disabled,
  onChange,
  error = false,
  value = undefined,
}: CatalogedTrackerDropdownProps) {
  const { data, isLoading } = useFetchCatalogedTrackers();

  const trackersByName: Map<string, NamedTrackerInfo> = useMemo(() => {
    const byName = new Map<string, NamedTrackerInfo>();

    (data?.trackers ?? []).forEach((tracker) => {
      byName.set(tracker.name, tracker);
    });

    return byName;
  }, [data]);

  const sortedTrackers: NamedTrackerInfo[] = useMemo(() => {
    if (data === undefined) {
      return [];
    }

    return data.trackers.sort((a, b) => {
      return a.name.localeCompare(b.name);
    });
  }, [data]);

  return (
    <Autocomplete
      fullWidth
      disabled={disabled || isLoading}
      renderInput={(params) => (
        <TextField
          {...params}
          autoFocus={autoFocus}
          error={error}
          placeholder={
            isLoading ? "Loading..." : "Select a tracker from the catalog..."
          }
          size="small"
          variant="outlined"
        />
      )}
      options={sortedTrackers.map((tracker) => tracker.name)}
      onChange={(_e, value) => onChange(trackersByName.get(value ?? ""))}
      value={value?.name ?? null}
    />
  );
}

export default CatalogedTrackerAutocomplete;
